import React from "react";
import commoncss from "../../css/common.module.css";
import FixedAssetSideBar from "../../components/fixedasset/FixedAssetSideBar";
import FaHeaders from "../../fixedassetelements/Headers/FaHeaders";
import MovementTable from "../../fixedassetelements/movementTable/MovementTable";

const FAMovementSummary = () => {
  return (
    <>
      <div style={{ display: "flex" }}>
        <FixedAssetSideBar activeTab={"Movement Summary"} />
        <div className={`${commoncss.widthScrHidden} px-4 py-2`}>
          <FaHeaders />
          <div style={{ paddingTop: "70px" }}>
           <MovementTable />
          </div>
        </div>
      </div>
    </>
  );
};

export default FAMovementSummary;
